"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagManagerSnippets = void 0;
var warn_1 = require("./utils/warn");
var TagManagerSnippets = /** @class */ (function () {
    function TagManagerSnippets() {
    }
    TagManagerSnippets.tags = function (_a) {
        var id = _a.id, domain = _a.domain, eventData = _a.eventData, preview = _a.preview, auth = _a.auth;
        var gtm_auth = "&gtm_auth=".concat(auth);
        var gtm_preview = "&gtm_preview=".concat(preview);
        if (!id) {
            (0, warn_1.default)('GTM ID is required');
        }
        else {
            var iframe = document.createElement('iframe');
            iframe.src = "".concat(domain, "/ns.html?id=").concat(id).concat(gtm_auth).concat(gtm_preview, "&gtm_cookies_win=x");
            iframe.height = '0';
            iframe.width = '0';
            iframe.style.display = 'none';
            iframe.style.visibility = 'hidden';
            iframe.id = 'tag-manager';
            var script = "\n      (function(w,d,s,l,i){w[l]=w[l]||[];\n        w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});\n        var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';\n        j.async=true;j.src='".concat(domain, "/gtm.js?id='+i+dl+'").concat(gtm_auth).concat(gtm_preview, "&gtm_cookies_win=x';\n        f.parentNode.insertBefore(j,f);\n      })(window,document,'script','dataLayer','").concat(id, "');");
            var eventDataVar = this.pushEvent(eventData);
            return {
                iframe: iframe,
                script: script,
                eventDataVar: eventDataVar
            };
        }
    };
    TagManagerSnippets.pushEvent = function (eventData) {
        return "\n      window.dataLayer = window.dataLayer || [];\n      window.dataLayer.length = 0;\n      window.dataLayer.push(function() {\n        this.reset();\n      })\n      window?.dataLayer.push(".concat(JSON.stringify(eventData), ")"); // first push
    };
    return TagManagerSnippets;
}());
exports.TagManagerSnippets = TagManagerSnippets;
//# sourceMappingURL=TagManagerSnippets.js.map